import React from "react";
import "./Services.css";

function Services({ standalone = false }) {
  const services = [
    {
      title: "Integrated Pipeline Repair Services",
      image: "/images/services2.webp",
      description:
        "Our integrated pipeline repair solutions help protect critical infrastructure, reduce downtime and keep energy operations safe, reliable and moving forward.",
    },

    {
      title: "Diving and Subsea Inspection, Maintenance & Repair Services (IMR)",
      image: "/images/diving and subsea installation.webp",
      description:
        "Specialized diving and subsea inspection, maintenance and repair services that protect underwater assets and support safe, reliable offshore operations.",
    },

    {
      title: "Shallow Offshore Hook-up & Commissioning",
      image: "/images/hookup and comissioning.webp",
      description:
        "Reliable shallow offshore hook-up and commissioning services that connect, test and prepare facilities for safe, efficient operation.",
    },

    {
      title: "Tank Farm Rehabilitation and Repair Services",
      image: "/images/Tank Farm Construction and Reh Services.webp",
      description:
        "Comprehensive tank farm rehabilitation and repair services that restore storage facilities, improve reliability and support safe, efficient operations.",
    },

    {
      title: "Vessels Supply & Operation",
      image: "/images/vessel suppy operations.webp",
      description:
        "Reliable vessel supply and operational support for offshore and marine activities, delivered with safety, efficiency and dependability.",
    },

    {
      title: "Dredging",
      image: "/images/dredging.webp",
      description:
        "Professional dredging solutions supporting marine construction, safe waterways and efficient offshore operations.",
    },
  ];

  return (
    <>
      {standalone && (
        <section className="services-page-hero">
          <img
            className="services-page-hero-image"
            src="/images/services2.webp"
            alt="Offshore pipeline construction and service operations"
          />
          <div className="services-page-hero-overlay" />
          <div className="services-container services-page-hero-content">
            <span className="services-eyebrow">SERVICES</span>
            <h1>Integrated services for offshore and energy operations.</h1>
            <p>
              Engineering, construction, subsea and maritime support delivered
              with safety and operational excellence.
            </p>
          </div>
        </section>
      )}
    <section className="services" id="services">

      {/* =================================================
          SECTION HEADER
          ================================================= */}

      <div className="services-container">

        <div className="services-header">

          <div>
            <span className="services-eyebrow">
              WHAT WE DO
            </span>

            <h2>
              Solutions Built
              <br />
              Around Your Needs.
            </h2>
          </div>

          <p className="services-header-text">
            We deliver integrated energy, maritime and
            engineering solutions built around safety,
            expertise and operational excellence.
          </p>

        </div>


        {/* =================================================
            SERVICES GRID
            ================================================= */}

        <div className="services-grid">

          {services.map((service) => (

            <a
              href="#services"
              className="service-card"
              key={service.title}
            >

              <div className="service-card-images">
                {Array.isArray(service.image) ? (
                  service.image.map((image) => (
                    <img
                      src={image}
                      alt=""
                      className="service-card-image"
                      key={image}
                    />
                  ))
                ) : (
                  <img
                    src={service.image}
                    alt=""
                    className="service-card-image"
                  />
                )}
              </div>

              <div className="service-card-top">
                <span className="service-arrow">
                  →
                </span>

              </div>


              <div className="service-card-content">

                <h3>
                  {service.title}
                </h3>

                <p>
                  {service.description}
                </p>

              </div>


              <div className="service-card-line"></div>

            </a>

          ))}

        </div>


        {/* =================================================
            BOTTOM CTA
            ================================================= */}

        <div className="services-footer">

          <p>
            Discover how Strides can support your next
            project.
          </p>

          <a
            href="/services"
            className="services-button"
          >
            <span>View All Services</span>

            <span className="services-button-arrow">
              →
            </span>
          </a>

        </div>

      </div>

      </section>
    </>
  );
}

export default Services; 